module.exports = __webpack_public_path__ + "2aacad68e425dab7bece85d838e58eae.woff2";